/**
 * Enlaces entre pantallas. Los flujos que se abren encima de otra pantalla (hojas y modales) viven
 * en parámetros de la URL, así funcionan con "atrás" y se pueden compartir.
 */
const encode = encodeURIComponent;

export const links = {
  /** C02 y C03: registro o ingreso con código de WhatsApp; `next` es a dónde volver al terminar. */
  login: (next?: string) => `/?registro=1${next ? `&next=${encode(next)}` : ''}`,
  /** Igual que `login`, pero el primer paso dice que la sesión caducó. */
  loginExpired: (next?: string) => `/?registro=1&caduco=1${next ? `&next=${encode(next)}` : ''}`,
  map: '/mapa',
  /** C04b: hoja (o panel en desktop) de la estación sobre el mapa. */
  mapStation: (slug: string) => `/mapa?estacion=${encode(slug)}`,
  station: (slug: string) => `/estaciones/${encode(slug)}`,
  beverage: (slug: string) => `/estaciones/${encode(slug)}/bebida`,
  /** C07: hoja de calificar (con el paso del código de la barra si aún no hay sello). */
  rate: (slug: string) => `/estaciones/${encode(slug)}?calificar=1`,
  /** C08: confirmación del voto oficial. */
  vote: (slug: string) => `/estaciones/${encode(slug)}?votar=1`,
  voteConfirmed: '/voto/confirmado',
  ranking: (tab?: string) => (tab ? `/ranking?tab=${encode(tab)}` : '/ranking'),
  /** Pestaña "Premios" del ranking: puesto por sellos y premios del ciclo abierto. */
  prizes: '/ranking?tab=premios',
  /** Landing pública de ganadores de los ciclos de premios. */
  winners: '/ganadores',
  route: '/ruta',
  passport: '/pasaporte',
  profile: '/perfil',
  /**
   * Hoja "Tengo un código" (registrar una visita). La abre cualquier pantalla con layout de cliente
   * agregando este parámetro a la URL actual.
   */
  checkinParam: 'codigo',
} as const;
